import axios from "axios";

const putHhDataTemp = async (
  uploadUrl: string,
  contentType: string,
  file: File
): Promise<void> => {
  await axios.put(uploadUrl, file, {
    headers: {
      "Content-Type": contentType,
    },
  });
};

export default putHhDataTemp;
